import { Immutable } from "immer";
import React from "react";
import Modal from "react-modal";
import { t } from "ttag";

import { constants } from "@reactivated/constants";

import { WebPageURL } from "../../models/nominals";
import { useAppSelector } from "../../store/reducers";
import { focusElement } from "../../utils/keyboardFocus";
import { usePageSetting } from "../../utils/settings";
import { ContactUsModalContent } from "../ContactUsModalContent";

const AppSlug = constants["tsicommon.types.AppSlug"];

type IProps = Immutable<{
    chatOfflineLink?: WebPageURL;
}> & {
    isOpen: boolean;
    onClose: (
        event: React.MouseEvent<Element> | React.KeyboardEvent<Element>,
    ) => void;
};

export const ContactUsModal = (props: IProps): React.ReactNode => {
    const basket = useAppSelector((state) => state.checkout.data.basket);
    const appSlug = usePageSetting("app_slug") || "";
    const isStearns = appSlug === AppSlug.STEARNS;

    // Stearns uses v2026 tokens (toggle-aware). Every other site keeps the
    // original hardcoded values, since the tokens live only in Stearns.
    const modalStylePhone: Modal.Styles = {
        overlay: {
            zIndex: 200,
            ...(isStearns
                ? {
                      backgroundColor: "var(--contact-us-modal--overlay-color)",
                  }
                : {}),
        },
        content: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            margin: "auto",
            padding: "25px",
            overflowX: "hidden",
            overflowY: "auto",
            boxShadow: "none",
            borderRadius: "10px",
            border: "1px solid var(--contact-us-modal--border-color, #c9ced1)",
            backgroundColor: "var(--color-stone-35, #f7f7f7)",
        },
    };

    return (
        <Modal
            contentLabel={t`Contact Us`}
            aria={{ modal: true }}
            style={modalStylePhone}
            className="service-footer-modal-phone"
            isOpen={props.isOpen}
            onRequestClose={props.onClose}
            onAfterOpen={() => {
                focusElement(".service-footer-modal__close");
            }}
        >
            <ContactUsModalContent
                basket={basket}
                onCloseModalContact={props.onClose}
                chatOfflineLink={props.chatOfflineLink}
            />
        </Modal>
    );
};
